import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonResult } from '../core/json-result.model';
import { OfficeVirtualClient } from '../models/office-virtual-client.model';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Login } from '../models/login.model';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from './common.service';
import { takeUntil, delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BackOfficeService {

  constructor(private httpClient: HttpClient,
    private handler: HttpBackend,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }

  changePasswordClient(data: any): Observable<JsonResult<any>> {
    const url = `${this.environmentService.backOfficeServiceUrl}Login/ChangePasswordClient`;
    return this.httpClient.post<JsonResult<any>>(url, data);
  }
  sendPasswordRecovery(email: string): Observable<JsonResult<any>> {
    let url = `${this.environmentService.backOfficeServiceUrl}Login/PasswordRecovery`;
    let data = { email: email }
    return this.httpClient.post<JsonResult<any>>(url, data);
  }
  createUser(officeVirtualClient: OfficeVirtualClient): Observable<JsonResult<any>> {
    const url = `${this.environmentService.backOfficeServiceUrl}Login/CreateUser`;
    return this.httpClient.post<JsonResult<any>>(url, officeVirtualClient);
  }
  changeCurrentUserPassword(data: any): Observable<JsonResult<any>> {
    const url = `${this.environmentService.backOfficeServiceUrl}User/CurrentUserPasswordChange`;
    return this.httpClient.post<JsonResult<any>>(url, data);
  }
  portalWebUrl() {
    return this.environmentService.portalWebUrl;
  }
  allNotificationByIdTypeUser(notificationTypeIdWithUser: any): Observable<JsonResult<any>> {
    const url = `${this.environmentService.backOfficeServiceUrl}Notification/GetAllNotificationByIdTypeUser`;
    return this.httpClient.post<JsonResult<any>>(url, notificationTypeIdWithUser).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
  updateReadingNotification(Ids: number[]): Observable<JsonResult<any>> {
    const url = `${this.environmentService.backOfficeServiceUrl}Notification/UpdateReadingNotification`;
    return this.httpClient.put<JsonResult<any>>(url, Ids).pipe(delay(5000));
  }
  login(data: Login) {
    const url = `${this.environmentService.backOfficeServiceUrl}Login/Access`;
    return this.httpClient.post<JsonResult<any>>(url, data);
  }

  getAccountLimit() {
    const url = `${this.environmentService.backOfficeServiceUrl}Setting/GetSetting/1`;
    return this.httpClient.get<JsonResult<any>>(url).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  getTemporaryAccessToken(temporaryAccessId: string) {
    const url = `${this.environmentService.backOfficeServiceUrl}Login/TemporaryAccessToken`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append("temporaryAccessId", temporaryAccessId);
    return this.httpClient.get<JsonResult<any>>(url, { params: httpParams });
  }
  getTemporaryAccess(data: Login) {
    const url = `${this.environmentService.backOfficeServiceUrl}Login/TemporaryAccess`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append("username", data.username);
    httpParams = httpParams.append("password", data.password);
    httpParams = httpParams.append("platform", data.platform);
    return this.httpClient.get<JsonResult<any>>(url, { params: httpParams });
  }
  closeSession() {
    const url = `${this.environmentService.backOfficeServiceUrl}Sessions/CloseSession`;
    return this.httpClient.post<JsonResult<any>>(url, null);
  }
  activateUser(userKey: string) {
    const url = `${this.environmentService.backOfficeServiceUrl}User/ActivateEmail`;
    return this.httpClient.post<JsonResult<any>>(url, { idUser: userKey });
  }
  GetPopupPublishedByTypeDisplay(visualizacion: string, notificacionPara: string, tipoCliente: string, creditoDisponible: boolean = false) {
    const url = `${this.environmentService.backOfficeServiceUrl}ConfiguracionPopup/GetPopupPublishedByTypeDisplay`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append("visualizacion", visualizacion);
    httpParams = httpParams.append("notificacionPara", notificacionPara);
    httpParams = httpParams.append("tipoCliente", tipoCliente);
    httpParams = httpParams.append("creditoDisponible", String(creditoDisponible));
    return this.httpClient.get<JsonResult<any>>(url, { params: httpParams });
  }
  GetConfigurationKnowReceipt() {
    const url = `${this.environmentService.backOfficeServiceUrl}ConfigurationReceipt/GetConfigurationKnowReceipt`;
    return this.httpClient.get<JsonResult<any>>(url, {});
  }
  GetNotifications(notificationTypeIdWithUser: any): Observable<JsonResult<any>> {
    //this.httpClient = new HttpClient(this.handler);
    const authToken = localStorage.getItem("token");
    const httpOptions = {
      headers: new HttpHeaders({
        "X-Skip-Interceptor" : '',
        "Authorization": `Bearer ${authToken}`,
      })
    };
    const url = `${this.environmentService.backOfficeServiceUrl}Notification/GetNotificationsBox`;
    return this.httpClient.post<JsonResult<any>>(url, notificationTypeIdWithUser, httpOptions).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  updateReadingNotifications(notifications: any[]): Observable<JsonResult<any>> {
    const url = `${this.environmentService.backOfficeServiceUrl}Notification/UpdateReadingNotifications`;
    return this.httpClient.put<JsonResult<any>>(url, notifications).pipe(delay(5000));
  }

  GetUser(idUser: string){
    const url = `${this.environmentService.backOfficeServiceUrl}User/GetUser/${idUser}`;
    return this.httpClient.get<JsonResult<any>>(url).pipe(delay(5000));
  }

  getMensajeAlerta(idAlerta: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}VirtualStore/MensajePagina/${idAlerta}`;
    return this.httpClient.get<JsonResult<any>>(url).toPromise();
  }
}